import {
  TypeRegistry,
  ParserRegistry,
  Encoder,
  Decoder,
  GlobalId,
  StringParser
} from '@tryon-technology/global-id';

const typeRegistry = new TypeRegistry();
const parserRegistry = new ParserRegistry(typeRegistry);

typeRegistry.registerType('Customer', 'cus');
parserRegistry.registerParser('cus', 'legacy', new StringParser());
typeRegistry.registerType('Proposal', 'proposal');
parserRegistry.registerParser('proposal', 'legacy', new StringParser());
typeRegistry.registerType('DesignerUserType', 'dut');
parserRegistry.registerParser('dut', 'legacy', new StringParser());
typeRegistry.registerType('DesignerSession', 'dses');
parserRegistry.registerParser('dses', 'legacy', new StringParser());

const encoder = new Encoder(parserRegistry, typeRegistry);
const decoder = new Decoder(parserRegistry, typeRegistry);

const encode = (id: GlobalId<unknown>): string => {
  return encoder.encode(id);
};

const decode = (id: string): GlobalId<never> => {
  return decoder.decode(id);
};

/** Payload for single-token URL: no leadId/proposalId/userType visible in the URL. */
export interface DesignerSessionPayload {
  leadId?: string | null;
  proposalId?: string | null;
  userType?: string | null;
  /** Canvas row id (designer/canvas); omit or null = default canvas for lead (same id as lead). */
  designId?: string | null;
}

const DESIGNER_SESSION_PREFIX = 'dses_';

function encodeSession(payload: DesignerSessionPayload): string {
  const json = JSON.stringify({
    leadId: payload.leadId ?? null,
    proposalId: payload.proposalId ?? null,
    userType: payload.userType ?? null,
    designId: payload.designId ?? null
  });
  return encoder.encode(
    new GlobalId('DesignerSession', 'legacy', json) as GlobalId<unknown>
  );
}

function decodeSession(token: string): DesignerSessionPayload | null {
  if (!token?.startsWith(DESIGNER_SESSION_PREFIX)) return null;
  try {
    const decoded = decoder.decode(token);
    if (decoded.getType() !== 'DesignerSession') return null;
    const parsed = JSON.parse(
      String(decoded.getValue())
    ) as DesignerSessionPayload;
    return {
      leadId: parsed.leadId ?? null,
      proposalId: parsed.proposalId ?? null,
      userType: parsed.userType ?? null,
      designId: parsed.designId ?? null
    };
  } catch {
    return null;
  }
}

export { encode, decode, GlobalId, encodeSession, decodeSession };
